export default {
  CUSTOMER: "Customer",
  PROVIDER: "Provider",
  PHOTOGRAPHER: "Photographer",
};
